import * as t from "io-ts";

export const LocationMetaGeofenceEventCodec = t.intersection([
  t.type({
    id: t.string,
    siteId: t.string,
    siteName: t.string,
    virtual: t.boolean,
    triggerType: t.string,
    inDttm: t.number,
  }),
  t.partial({
    siteCompanyId: t.string,
    siteCompanyName: t.string,
    outDttm: t.number,
    source: t.string,
    detection: t.string,
  }),
]);

export const LocationMetaGeofenceEventArrayCodec = t.array(
  LocationMetaGeofenceEventCodec
);

export type LocationMetaGeofenceEvent = t.TypeOf<typeof LocationMetaGeofenceEventCodec>;
